export function initStickyHeader() {
    const stickyNav = document.getElementById('sticky-nav')
    const joinHeader = document.getElementById('join-header')
    const htmlDoc = document.getElementsByTagName('html')[0]
    let lastScroll = 0

    if (!stickyNav || !joinHeader) {
        return
    }

    window.addEventListener('scroll', () => {
        htmlDoc.classList.add('overscroll')
        const currentScroll = window.pageYOffset

        // Get relative position of the main header
        const targetStickyPos = joinHeader.offsetTop + joinHeader.clientHeight;
       
        // Conditionally show/sticky-hide the sticky nav
        if (currentScroll > targetStickyPos) {
            // Show the sticky navigation
            stickyNav.classList.remove('sticky-hidden', 'pointer-events-none')
        } else {
            stickyNav.classList.add('sticky-hidden', 'pointer-events-none')
        }

        lastScroll = currentScroll
    })
}